module.exports = __webpack_public_path__ + "img/TAB_05_Passive.ae4b282b.svg";